// Document Module-specific validation - Uses generic validation utility
import { createValidation } from '../../../utils/validation';

/**
 * Document Module-specific validation factory
 * This is a thin wrapper around the generic validation utility
 * for backwards compatibility with existing document module code
 */
export const createDocumentModuleValidation = (fields) => {
  const validation = createValidation(fields);
  
  // Return the same interface but with document module-specific method names
  return {
    schema: validation.schema,
    validateDocumentModuleData: validation.validateData,
    validateField: validation.validateField
  };
};

// Default export for backwards compatibility
export default createDocumentModuleValidation;

